var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenewalRemark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.207,
    height: 19.207,
    viewBox: "0 0 19.207 19.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1107",
    "data-name": "Group 1107",
    transform: "translate(-1684.5 -605.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M4,0,8,5H0Z",
    transform: "matrix(0.719, -0.695, 0.695, 0.719, 1694, 620.557)",
    fill: "#E4EAFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1105",
    "data-name": "Group 1105",
    transform: "translate(747.5 -256.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M949.239,874.239V880.5H937.5v-18h18v11.739Z",
    fill: "#E4EAFF",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_184",
    "data-name": "Line 184",
    x1: 6,
    y2: 6,
    transform: "translate(949.5 874.5)",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M942,872l.643-1a.706.706,0,0,1,1.286,0,.706.706,0,0,0,1.286,0,.706.706,0,0,1,1.286,0,.706.706,0,0,0,1.286,0,.706.706,0,0,1,1.286,0,.706.706,0,0,0,1.286,0l.643-1",
    transform: "translate(0 -1.786)",
    fill: "#E4EAFF",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M942,877l1-1a1.415,1.415,0,0,1,2,0,1.415,1.415,0,0,0,2,0",
    transform: "translate(0 -3.031)",
    fill: "#E4EAFF",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewalRemark);
export default __webpack_public_path__ + "static/media/renewalRemark.f8c37b1902b7aedc6051ff454100a001.svg";
export { ForwardRef as ReactComponent };